import { useState } from 'react';
import classNames from 'classnames';

import lang from '../../lib/language';

import Button from '../Button/Button';
import { ButtonTypesEnum } from '../Button/Button.types';
import useIsMobile from '../hooks/useIsMobile';

import DividendPayers from './DividendPayers';
import HighGrowthCompanies from './HighGrowthCompanies';
import { LongTermInvestmentsProps } from './LongTermInvestments.types';

import styles from './LongTermInvestments.module.scss';

const DESKTOP_ROW_LIMIT = 10;

const LongTermInvestments = ({
  dividendPayers,
  highGrowthCompanies,
  hasTabs,
  onViewAllClick,
  renderTabs,
  renderDesktopTabs,
}: LongTermInvestmentsProps) => {
  const { isMobile } = useIsMobile();
  const [, setCurrentTab] = useState<number>(0);

  const tabs = [
    {
      text: lang.commonDiscoverDividendPayers(),
      component: (
        <DividendPayers dividendPayerContent={dividendPayers.slice(0, DESKTOP_ROW_LIMIT)} />
      ),
    },
    {
      text: lang.commonDiscoverHighGrowthCompanies(),
      component: (
        <HighGrowthCompanies companiesContent={highGrowthCompanies.slice(0, DESKTOP_ROW_LIMIT)} />
      ),
    },
  ];

  const title = (
    <h6 className={classNames(GlobalClassesEnum.CommonDiscoverTitle, styles.title)}>
      {lang.commonDiscoverSubtitleLongTermInvestments()}
    </h6>
  );

  if (isMobile) {
    return (
      <>
        <div className={styles.titleWrapper}>
          {title}
          <div>
            <Button
              variant={ButtonTypesEnum.Link}
              onClick={onViewAllClick}
              className={styles.viewAll}
            >
              {lang.commonViewAll()}
            </Button>
          </div>
        </div>
        <div className={styles.tabsWrapper}>
          {hasTabs && renderTabs({ tabs, onTabChange: setCurrentTab })}
        </div>
      </>
    );
  }

  return (
    <>
      {title}
      {renderDesktopTabs({ tabs, onTabChange: setCurrentTab })}
    </>
  );
};

export default LongTermInvestments;
